<!--第三方页面直接修改个人签名-->
<template>
    <div class="signature-third"
         v-if="showPage">
        <template v-if="isSignature">
            <signature-modal @saveSignature="handleBase64"
                             :pageFrom="pageFrom"></signature-modal>
        </template>
        <template v-else>
            <attention :codeStatus="codeStatus"></attention>
        </template>
    </div>

</template>
<script>
import signatureModal from "./model.vue";
import attention from "./attention.vue";

export default {
    props: {
        pageFrom: {
            type: String
        }
    },
    components: {
        signatureModal,
        attention
    },
    data () {
        return {
            isSignature: true, // 当前url 携带的token
            codeStatus: 0,
            showPage: false
        };
    },
    mounted () {
        let iframeElements = document.querySelectorAll('iframe');
        Array.from(iframeElements).forEach(node => {
            node.className += " hidden-elements";
        });
        let appElements = document.querySelector('#app');
        appElements.className += ' app-fullscreen';
        this.showPage = true;
    },
    computed: {
        fromThird () {
            return !!this.$route.query.QID;
        },
        // 是否是嵌入式页面
        isEmbed () {
            return this.$route.query.embeded === 'true';
        },
        // token
        zwdt_access_token () {
            return this.$route.query.zwdt_access_token;
        },
        // signSource
        signSource () {
            return this.$route.query.signSource;
        }
    },
    methods: {
        handleBase64 (base64) {
            this.base64 = base64;
            this.setSignature();
        },
        showAttention (codeStatus) {
            this.codeStatus = codeStatus;
            this.isSignature = false;
        },

        /** 获取系统配置 */
        getSystemConfig () {
            let url,
                data = new FormData(),
                headers = {};
            if (this.signSource === 'ZWDT_CUSTOM') {
                url = '/open/seal/custom/applyseal';
            } else if (this.signSource === 'ZWDT_OPEN' || this.zwdt_access_token) {
                url = '/open/seal/applyseal';
            } else {
                url = "/seal/applyseal";
            }
            data.append('imgBase64', this.base64);
            data.append('transparen', true);
            data.append('zoom', true);
            data.append('rotate', true);

            if (this.fromThird) {
                let headerKey = this.isEmbed ? 'X-OPENTOKEN' : 'X-QID';
                headers[headerKey] = this.$route.query.QID;
            } else if (this.zwdt_access_token) {
                let headerKey = 'zwdt_access_token';
                headers[headerKey] = this.zwdt_access_token;
                data.append(headerKey, this.zwdt_access_token);
            }
            return {
                url,
                data,
                headers,
                method: 'POST'
            };
        },

        /** 保存签名 */
        setSignature () {
            const config = this.getSystemConfig();
            this.axios(config).then(res => {
                const data = res.data;
                if (data.code === 0) {
                    if (data.successPage) {
                        this.showAttention(1);
                        this.jumpToSuccessPage(data.successPage, data.preview);
                    } else if (this.fromThird || this.zwdt_access_token) {
                        this.showAttention(1);
                    } else {
                        history.go(-1);
                    }
                } else {
                    this.showAttention(0);
                }
            }).catch(err => {
                console.log(err);
            });
        }
    }
};
</script>
<style lang="less" scoped>
.hidden-elements {
    display: none;
}
.app-fullscreen {
    height: 100% !important;
}
body {
    height: 100%;
    overflow: auto;
}
.signature-third {
    height: 100%;
}
.icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
}

.inline {
    display: inline-block;
}

a {
    text-decoration: none;
}

button {
    border-radius: 3px;
}

.vertical-center {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -o-transform: translateY(-50%);
}

.horizon-center {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -o-transform: translateX(-50%);
}

.fl {
    float: left;
}

.fr {
    float: right;
}

.clearfix:before,
.clearfix:after {
    content: " ";
    display: table;
}

.clearfix:after {
    clear: both;
}

.ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
